// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6631730a","252":"bb16de18","670":"87b5cc2a","703":"2996d930","787":"3676b55b","869":"90c892cc"}[chunkId] + ".chunk.js";
};